

// GetAllNonWorkingHours
export const GET_ALL_NON_WORKING_HOURS = "GET_ALL_NON_WORKING_HOURS"
export const GET_ALL_NON_WORKING_HOURS_SUCCESS = "GET_ALL_NON_WORKING_HOURS_SUCCESS"
export const GET_ALL_NON_WORKING_HOURS_ERROR = "GET_ALL_NON_WORKING_HOURS_ERROR"

// insert and updater calculae incentive
export const INSERT_UPDATE_NON_WORKING_HOURS = "INSERT_UPDATE_NON_WORKING_HOURS"
export const INSERT_UPDATE_NON_WORKING_HOURS_SUCCESS = "INSERT_UPDATE_NON_WORKING_HOURS_SUCCESS"
export const INSERT_UPDATE_NON_WORKING_HOURS_ERROR = "INSERT_UPDATE_NON_WORKING_HOURS_ERROR"


// delete calculae incentive
export const DELETE_NON_WORKING_HOURS = "DELETE_NON_WORKING_HOURS"
export const DELETE_NON_WORKING_HOURS_SUCCESS = "DELETE_NON_WORKING_HOURS_SUCCESS"
export const DELETE_NON_WORKING_HOURS_ERROR = "DELETE_NON_WORKING_HOURS_ERROR"